<template>
  <div>
    <Breadcrumb :dataSource="breadcrumbList" />
    <div class="page-container" style="height: 87vh">
      <div class="flex-between">
        <div class="flex-align-center">
          <div class="title-2" style="margin-right: 20px">我的计划</div>
          <div>
            <a-radio-group
              v-model="planType"
              style="margin: 6px 0"
              @change="changePlanType"
              :disabled="radioGroupDisabled"
            >
              <a-radio-button
                v-for="(item, index) in planTypeList"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <a-button type="primary" style="margin-left: auto" @click="createPlan">新建计划</a-button>
      </div>
      <a-divider style="margin: 10px 0" />
      <PlanCard
        ref="planCardRef"
        :planType="planType"
        @loadingChange="(val) => (radioGroupDisabled = val)"
      />
    </div>
  </div>
</template>
<script>
import PlanCard from './components/PlanCard/index'
import Breadcrumb from '@/components/Breadcrumb/index'

export default {
  name: 'MyWordPlan',
  components: {
    PlanCard,
    Breadcrumb,
  },
  data() {
    return {
      breadcrumbList: [
        {
          label: '心理工作概览',
          isBack: true,
        },
        {
          label: '我的计划',
        },
      ],
      planType: 0,
      planTypeList: [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '校园活动',
          value: 1,
        },
        {
          label: '心理测评',
          value: 2,
        },
      ],
      planList: [],
      radioGroupDisabled: false,
    }
  },
  created() {
    // 获取路由传递参数
    const radioKey = this.$route.query.radioKey
    if (radioKey) {
      this.planType = Number(radioKey)
    }
  },
  methods: {
    changePlanType(e) {
      this.planType = e.target.value
    },
    createPlan() {
      this.$refs.planCardRef.createPlan()
    },
  },
}
</script>
<style scoped lang="less"></style>
